module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./LoginView.js"));
	}, "LoginView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LoginView!./src/pages/Login/LoginView.js
// module id = 860
// module chunks = 431